import { Input } from "reactstrap";

const IconedInput2 = ({
  icon,
  value,
  setValue,
  placeholder,
  type,
  options,
}) => {
  return (
    <div className="icon-input-2">
      {icon && <div>{icon}</div>}
      {type !== "select" ? (
        <Input
          value={value}
          type={type}
          placeholder={placeholder}
          onChange={(e) => setValue(e?.target?.value)}
        />
      ) : (
        <Input
          type="select"
          value={value}
          onChange={(e) => setValue(e?.target?.value)}
        >
          {options?.map((opt, k) => (
            <option key={k} selected={value === opt}>
              {opt}
            </option>
          ))}
        </Input>
      )}
    </div>
  );
};

export default IconedInput2;
